import { useIntl } from 'react-intl'
import { useRecoilState } from 'recoil'

import {
  Collapsible,
  Flex,
  FlexItem,
  FormElement,
  INPUT_NUMBER_VARIANT_DANGER,
  InputNumber,
  RadioButton,
  RADIOBUTTON_LABEL_FW_STANDARD,
  Text
} from 'mailup-web-components'

import { campaignState } from 'Pages/Campaign/recoil/state/campaign'
import { stepState } from 'Pages/Campaign/recoil/state/page'

const RadioButtonSource = () => {
  const intl = useIntl()

  const [{ CheckNumberOfNewContents, CheckFrequencyType }, setCampaign] =
    useRecoilState(campaignState)
  const [
    {
      step3: {
        sendingFrequency: { numberNewContentIsDirty }
      }
    },
    setStepState
  ] = useRecoilState(stepState)

  const handleChange = () => {
    setCampaign((prev) => ({ ...prev, CheckFrequencyType: 1, isDirty: true }))
  }

  const handleChangeNumber = (value) => {
    const parsedValue = isNaN(parseInt(value)) ? 0 : parseInt(value)
    setCampaign((prev) => ({
      ...prev,
      CheckNumberOfNewContents: parsedValue,
      isDirty: true
    }))
    setStepState((prev) => ({
      ...prev,
      step3: {
        ...prev.step3,
        sendingFrequency: {
          ...prev.sendingFrequency,
          numberNewContentIsDirty: true
        }
      }
    }))
  }

  return (
    <>
      <RadioButton
        checked={CheckFrequencyType === 1 || CheckFrequencyType === 0}
        id='radio-button--source'
        label={intl.formatMessage({
          id: 'Load.ContentsCampaignWizard.FrequencySimple'
        })}
        labelVariant={RADIOBUTTON_LABEL_FW_STANDARD}
        name='radio-button--source'
        onChange={handleChange}
        value={1}
        data-mu-test='campaign__step-3__radio-button-source'
      />
      {(CheckFrequencyType === 1 || CheckFrequencyType === 0) && (
        <Collapsible
          collpased={CheckFrequencyType === 1 || CheckFrequencyType === 0}
        >
          <Flex alignItems='baseline' margin='16px 0 0 26px'>
            <Text>
              {intl.formatMessage({
                id: 'Load.ContentsCampaignWizard.NuoviArticoliParte1'
              })}
            </Text>
            <FlexItem margin='0 8px'>
              <FormElement
                feedback={
                  numberNewContentIsDirty && !CheckNumberOfNewContents
                    ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
                    : undefined
                }
                variant={
                  numberNewContentIsDirty && !CheckNumberOfNewContents
                    ? 'danger'
                    : undefined
                }
              >
                <FlexItem width='80px'>
                  <InputNumber
                    min={1}
                    max={1000}
                    onChange={handleChangeNumber}
                    value={CheckNumberOfNewContents}
                    data-mu-test='campaign__step-3__input-number-CheckNumberOfNewContents'
                    variant={
                      !CheckNumberOfNewContents && numberNewContentIsDirty
                        ? INPUT_NUMBER_VARIANT_DANGER
                        : ''
                    }
                  />
                </FlexItem>
              </FormElement>
            </FlexItem>
            <Text>
              {intl.formatMessage({
                id: 'Load.ContentsCampaignWizard.NuoviArticoliParte2'
              })}
            </Text>
          </Flex>
        </Collapsible>
      )}
    </>
  )
}

export default RadioButtonSource
